<!-- eslint-disable no-mixed-spaces-and-tabs -->
<style >
._menu{
  background: #fff;
  max-width:300px;
}
.relative {
    position: relative;
}
.absolute {
    position: absolute;
}
.hidden {
    display: none;
}
._menu{
  z-index: 999;
  flex-direction: column;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 10px 20px rgba(64, 64, 64, 0.15);
  border:solid 1px rgba(64, 64, 64, 0.15);
}
.menu-list {
  margin: 0;
  display: block;
  width: 100%;
  padding: 0px;
}
.menu-list + .menu-list {
  border-top: 1px solid #ddd;
}
.menu-sub-list {
  display: none;
  padding: 0px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 10px 20px rgba(64, 64, 64, 0.15);
  position: absolute;
  left: 100%;
  right: 0;
  z-index: 100;
  width: 100%;
  top: 0;
  flex-direction: column;
}
.menu-sub-list:hover {
  display: flex;
}
.menu-item {
  position: relative;
  list-style: none;
}
.menu-button {
  font: inherit;
  border: 0;
  padding: 5px 5px;
  padding-right: 36px;
  width: 100%;
  text-align: left;
  display: flex;
  align-items: center;
  position: relative;
  background-color: #fff;
}
.menu-button:hover {
  background-color: #f1f3f7;
}
.menu-button:hover + .menu-sub-list {
  display: flex;
}
.menu-button:hover svg {
  stroke: #3a3c42;
}
.menu-button .bx{
  flex-shrink: 0;
  font-size:20px;
  margin-right: 10px;
  color: #898c94;
}
.menu-button .mdi-menu-right {
  margin-right: 0;
  position: absolute;
  right: 8px;
}
.menu-button .delete {
  color: #d92027;
}
.menu-button .orange{
  color: #dc9960;
}
.menu-button--green svg:first-of-type {
  stroke: #1eb8b1;
}
.menu-button--purple svg:first-of-type {
  stroke: #657cc4;
}
.menu-button--black svg:first-of-type {
  stroke: #3a3c42;
}
.menu-button--checked svg:nth-of-type(2) {
  stroke: #657cc4;
}
.collapsing {
  -webkit-transition: height .01s ease;
  transition: height .01s ease
}
.project-list-table {
    border-collapse: separate!important;
    border-spacing: 0 12px!important;
}
.online{
  border-left:solid 5px rgba(0, 207, 0, 0.349);
}
.online-bg{
  background-color:rgba(0, 207, 0, 0.349)!important
}
.table-bordered td {
    border: 1px solid #eff2f7;
}
.dropdown-menu{
  border: none;
}
#search-icon{
  animation: updown 5s ease infinite;
}
@keyframes updown {
  0% {
    transform: translateY(-25%);
  }

  50% {
    transform: translateY(25%);
  }

  100% {
    transform: translateY(-25%);
  }
}
.border-color-50{
  border-color:#50a5f1
}
.vs__dropdown-toggle{
  background:#fff;
  height:36px;
  border-color:#50a5f1
}
.__li:hover{
  background: rgb(227 227 227);
  cursor:pointer
}
#vgt-table td{
  vertical-align: middle;
}
.dot {
    width: 8px; 
    height: 8px; 
    border-radius: 50%; 
    display: inline-block;
    margin-right: 5px;
}
</style> 
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import CreateSetup from './list/setup'
import SetupList from './list/setup_list'
import FreezeModal from './modals/freeze'
import RenewalModal from './modals/renewal'
import HistoryModal from './modals/history'
import UpdateModal from './modals/update'
import PaymentHistoryModal from './modals/payment_history'
import CreatePaymentModal from './modals/create_payment'
import AptModal from './modals/apt_modal'
import FaultHistory from './modals/fault_history'
import KurulumModal from './modals/kurulum_modal'
import EvrakModal from './modals/evrak_modal'
import AntenModal from './modals/anten_modal'
import SatisModal from './modals/satis_modal'
import PayLink from './modals/paylink_modal'
import SpeedModal from './modals/speed_modal'
import PortModal from './modals/port_modal'
import SmsModal from './modals/sms_modal'

import ApartmentUnderClientList from "../apartment/clients_list";
import Loader from "@/components/widgets/loader.vue";

import Vue from 'vue';
import { notify } from '@/helpers/notify' 
import 'leaflet/dist/leaflet.css'

import {  mapActions, mapGetters } from 'vuex';

export default {
  page: {
    title: "Ara",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    CreateSetup,
    FreezeModal,
    RenewalModal,
    HistoryModal,
    UpdateModal,
    PaymentHistoryModal,
    CreatePaymentModal,
    SetupList,
    AptModal,
    FaultHistory,
    KurulumModal,
    AntenModal,
    SatisModal,
    PayLink,
    ApartmentUnderClientList,
    Loader,
    SpeedModal,
    PortModal,
    SmsModal,
    EvrakModal
  },
  data() {
    return {
      title: "ARA",
      items: [
        {
          text: "ANASAYFA",
          href: "/",
        },
        {
          text: "ARA",
          active: true,
        },
      ],
      antenData:{},
      satisData:{},
      antenModalOpen: 0,
      satisModalOpen: 0,
      apartmentListOpen: 0,
      kurulumModalOpen: 0,
      evrakModalOpen: 0,
      renewalModalOpen: 0,
      updateModal: 0,
      modelOpen:0,
      faultData: {},
      mainExplaine: '',
      aptData:{},
      setupData:{},
      hizmetData:{},
      data: {},
     	opened: [],
      openResult:false,
      isLoading: true,
      detailSearch:false,
      search:{
        username:'',
        fullname:'',
        phonenumber:'',
        mac:'',
        apt:''
      },
      list:{
        groups:[],
        dealers:[],
        tariffs:[],
      },
      modalData:{},
      form:{
        name: 'fullname'
      },
      rows: [],
      subsList:{
        username:{},
        fullname:{},
        phonenumber:{},
        mac:{},
        apt:{},
      },
      searched: false,
      freezeData:{},
      renewalData:{},
      subsBalance:0,
      historyData:{},
      paymentHistoryData:{},
      updateData:{},
      kurulumDetay:{},
      evrakDetay:{},
      selectApartmentId:null,
      searchList:[
        { title: 'Kullanıcı Adı', val: 'username'},
        { title: 'İsim Soyisim', val: 'fullname'},
        { title: 'Telefon', val: 'phonenumber'},
        { title: 'M.A.C.', val: 'mac'},
        { title: 'Apartman Sistemi', val: 'apt'},
      ],
      searchColumn:'',
      rowIndex:null,
      loading:false,
      paylinkModalOpen:0,
      paylinkData:{},
      hizModalOpen:0,
      portModalOpen:0,
      smsModalOpen:0,
      hizData:{},
      portData:{},
      smsData:{},
      isOnline:0,
    };
  },

  mounted(){
    this.$store.dispatch('searchClient/empty');
    document.getElementsByClassName('page-content')[0].style.minHeight = "500px";
    
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const username = urlParams.get('username')

    if(username){
      this.form.name = 'username'
      this.search.username = username
      this.fetchOptions(true, 'username')
    }
  },

  computed:{
      ...mapGetters('authfack',['settings']), 
      getAntenSetting(){
        return this.settings?.anten == true
      },
      liste(){
        return this.$store.getters["searchClient/getSearchClient"]
      },
      placeholder(){
        let output
        switch (this.form.name) {
          case 'username':
            output = 'Kullanıcı Adı';
            break;
          case 'fullname':
            output = 'İsim Soyisim';
            break;
          case 'phonenumber':
            output= 'Telefon Numarası';
            break;
          case 'mac':
            output= 'M.A.C Adresi';
            break;
        }
        return output
      },
  },
  
  methods: {
    ...mapActions('detail', ['setUserDetail']),
    
    ability(ably){
        const userdata = JSON.parse(localStorage.getItem('userdata'))
        if(ably.indexOf('|') > -1){ // admin
          let currentRole = ably.split('|')
          return currentRole.includes(userdata.role_name)
        }
        return userdata.role_name == ably
    },
    toggle(id) {
      //this.$store.dispatch('searchClient/updateItemName', [{name:'rowId', data:'1'},{name:'fname', data:'serdarr123'}]);
    	const index = this.opened.indexOf(id);
      if (index > -1) {
      	this.opened.splice(index, 1)
      } else {
      	this.opened.push(id)
      }
    },
    formSubmit(){
      this.updateParams({columnFilters : {...this.form}});
      this.loadItems()
    },
    allClear(){
      this.form = {}
    },
    fetchOptions(checked = '',key = null){
      if(this.search[key].length < 4) return 
      
      this.searchColumn = key
      this.$http.get('/members/search?'+key +'='+ this.search[key])
            .then(response => {
              this.subsList[key] =  response.data.content 
              this.openResult = true
              if(checked == true){
                  this.changedLabel(response.data.content[0])
              }
            })
       
    },
    changedLabel(e){
      this.$http.get(`/members/getSubsById/${e.id}`)
      .then((response) =>{
        this.openResult = false
        const e = response.data
        this.detailSearch = false

        let labelColor = ''
        let label = 'Aktif'

        this.isOnline = e.is_online
        
        /*
        if(e.status == 1){
          labelColor = '#7eff7e';
          label = 'Aktif'
        }*/
       
        if(e.status == 2){ // süresi bitmiş açık mavi
            labelColor = '#0064ff47'
            label = 'Süresi Bitmiş'
        }  
          
        if(e.status == 6){
          labelColor  = '#ffc0cb8c'
          label = 'Söküm Listesinde'
        }

        if(e.status == 3){
          labelColor = '#ffff005e'
          label = 'Sökülmüş'
        }
        if(e.status == 4){
          labelColor = '#c3c3c39e'
          label = 'Dondurulmuş'
        }

                /**
                   * 
                   *  "-1" => "Onay Bekleyen",
                      "0" => "Deaktif",
                      "1" => "Aktif",
                      "2" => "Süreden Pasif",
                      "3" => "Söküldü", iptal
                      "4" => "Dondurulmuş Abone",
                      "5" => "Potansiyel Abone",
                      "6" => "sökülecek"
                   */
                  // iptal #ff00009e
                  // donuk #c3c3c39e
                  // nakil taşıma #72434382
                  // söküm listesi #ffc0cb8c
                  // sökülenler #ffff005e
        this.$store.dispatch('searchClient/setSearchClient', { ...e, labelColor, label });
        this.rows.unshift({ ...e, labelColor, label })
      })
    },
    createSetup(subs_id){
      this.data = { type:1, subs_id }
      this.$parent.$bvModal.show('setup')
    },
    createFault(subs_id){
      this.data = { type:3, subs_id }
      this.$parent.$bvModal.show('setup')
    },
    createSokum(subs_id){
      this.data = { type:2, subs_id }
      this.$parent.$bvModal.show('setup')
    },
    createTasima(subs_id){
      this.data = { type:4, subs_id }
      this.$parent.$bvModal.show('setup')
    },
    randevuVer(){
      this.createSetup(this.currentRow.id)
    },
    gunEkle(){
      Vue.swal({
          title: "+2 Gün Ekleme",
          text: "Bitiş tarihine 2 gün eklemek istiyormusunuz?",
          showCancelButton: true,
          cancelButtonText: "İptal",
          confirmButtonText: "Evet, ekle!"
      }).then((result) => {
          if (result.value) {
            this.loading = true
            this.$http.get('/members/' + this.currentRow.id + '/add2Days')
            .then(response => {
                this.loading = false
                if(response.data.code == 100){
                  return notify.success(response.data.message)
                }
                return notify.error(response.data.message)
            })
          }
      });
      
    },
    dondur(){
      this.freezeData = { 
        direction: this.currentRow.status == 4  ? 2 : 1, // dondur 2 çöz
        ...this.currentRow
      }
      this.$parent.$bvModal.show('freeze_modal')
    },
    yenile(){

      if(this.currentRow.installment){
        this.$store.dispatch('userDetail/setUserDetail', {  id:this.currentRow.id, component:'onodeme' });
        this.$parent.$bvModal.show('create_payment_modal')
        return false
      }
    
      this.subsBalance = this.currentRow.balance  
      this.renewalData = this.currentRow;
      this.renewalModalOpen = this.getRandomInt()
      this.$parent.$bvModal.show('renewal_modal')
    },
    islemler(){
      this.historyData = { 
        url:`/members/${this.currentRow.id}/logs`,
        title:'İşlem Geçmişi',
        columns:[
          {
            label: 'Tarih',
            field: 'created_at',
            sortable:false,
          },
          {
            label: 'İşlemi Yapan',
            field: 'user_name',
            sortable:false,
          }, 
          {
            label: 'Açıklama',
            field: 'content',
            sortable:false,
          },
        ]
      }
      this.$parent.$bvModal.show('history_modal')
    },
    port(){
      this.historyData = { 
        url:'/members/' + this.currentRow.username + '/radpostauth',
        title:'Port Geçmişi',
        columns:[
          {
            label: 'Kullanıcı Adı',
            field: 'username',
            sortable:false,
          },
          {
            label: 'Şifre',
            field: 'pass',
            sortable:false,
          },
          {
            label: 'Servis İsmi',
            field: 'service_name',
            sortable:false,
          },
          {
            label: 'Cevap',
            field: 'reply',
            sortable:false,
          },
          {
            label: 'İşlem Tarihi',
            field: 'authdate',
            sortable:false,
          },
        ]
      }
      this.$parent.$bvModal.show('history_modal')
    },
    baglanti(){
      this.historyData = { 
        url:'/members/' + this.currentRow.username + '/radacct',
        title:'Bağlantı Geçmişi',
        columns:[
          {
            label: 'Kullanıcı Adı',
            field: 'username',
            sortable:false,
          }, 
          {
            label: 'Called',
            field: 'calledstationid',
            sortable:false,
          },
          {
            label: 'Başlangıç',
            field: this.acctstarttime,
            sortable:false,
          },
          {
            label: 'Bitiş',
            field:  this.acctstoptime,
            sortable:false,
          },
          {
            label: 'Süre',
            field: this.sure,
            sortable:false,
          },
          {
            label: 'Upload',
            field: this.acctinputoctets,
            sortable:false,
          },
          
          {
            label: 'Download',
            field: this.acctoutputoctets,
            sortable:false,
          },
          {
            label: 'Calling',
            field: 'callingstationid',
            sortable:false,
          },
          {
            label: 'İp Adres',
            field: 'framedipaddress',
            sortable:false,
          }
        ]
      }
      this.$parent.$bvModal.show('history_modal')
    },
    acctstarttime(obj){
      return this.formatDate(obj.acctstarttime, "DD.MM.YYYY HH:mm:ss");
    },
    acctstoptime(obj){
      return this.formatDate(obj.acctstoptime, "DD.MM.YYYY HH:mm:ss");
    },
    sure(obj){
      return this.secondsToDhms(obj.acctsessiontime);
    },
    acctinputoctets(obj){
       return this.formatBytes(obj.acctinputoctets);
    },
    acctoutputoctets(obj){
       return this.formatBytes(obj.acctoutputoctets);
    },
    getRandomInt() {
      return Math.floor(Math.random() * 1000);
    },
    ariza(){
      this.data = { type:3, subs_id:this.currentRow.id, referans:'search' }
      this.modelOpen = this.getRandomInt()
      this.$parent.$bvModal.show('setup')
    },
    sokum(){
      this.$http.post('/listeler/uzatmayanlar/event', {sok:this.currentRow.id})
        .then(() => notify.success('Söküm listesine atandı.'))
    },
    tasima(){
      this.data = { type:4, subs_id:this.currentRow.id, referans:'search' }
      this.modelOpen = this.getRandomInt()
      this.$parent.$bvModal.show('setup')
    },
    bilgiler(){
      this.$store.dispatch('userDetail/setUserDetail', { ...this.currentRow, bilgi:true});
      this.$parent.$bvModal.show('update_modal')
    },
    guncelle(type){
      const form = { ...this.currentRow, type}
      this.$store.dispatch('userDetail/setUserDetail', form);
      this.$parent.$bvModal.show('update_modal')
    },
    paymentHistory(){
      this.paymentHistoryData = { ...this.currentRow }
      this.$parent.$bvModal.show('payment_history_modal')
    },
    createPayment(type){
        const form = { ...this.currentRow, paymnet_type: type}
        this.$store.dispatch('userDetail/setUserDetail', { ...form, component:'odeme' });
        this.$bvModal.show('create_payment_modal')
        this.$parent.$bvModal.show('create_payment_modal')
    },
    arizaListesi(){
      const { fname, lname, id} = this.currentRow
      this.faultData = { 
          fullname: fname +' '+ lname,
          url: `/technic-service?subscription_id=${id}&type=3&status=6`
        }
      this.$parent.$bvModal.show('gecmis_arizalari')
    },
    apt(){
        this.aptData = this.currentRow
        this.$parent.$bvModal.show('apt_modal')
    },
    reConnect(){
      this.loading = true
      this.$http.get('/members/'+ this.currentRow.id + '/kick')
      .then(response => {
          this.loading = false
          if(response.data.code == 100){
            return notify.success(response.data.message)
          }
          return notify.error(response.data.message)
        })
            
    },
    context(e, row,i){
      e.preventDefault();
        
      const menus = document.querySelectorAll('._menu')
      if(menus.length> 0){
        Array.from(menus).map(e => {
            e.classList.add('hidden')
        }) 
      }
      this.rowIndex = i
      this.currentRow = row

      //var menuHeight = document.getElementById('menu').offsetHeight;
      var menuHeight = 455;
      const ele = document.getElementById('vgt-table'); 
      ele.style.marginBottom = menuHeight + 'px'


      const menu = document.getElementById('menu' + i);
      const rect = ele.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      // Set the position for the menu
      menu.style.top = `${y}px`;
      menu.style.left = `${x}px`;
      menu.classList.remove('hidden');
      document.addEventListener('click', this.documentClickHandler);
    },
    documentClickHandler(e) {
        const menu = document.getElementById('menu' + this.rowIndex);
        const isClickedOutside = !menu.contains(e.target);
        if (isClickedOutside) {
            const ele = document.getElementById('vgt-table'); 
            ele.style.marginBottom = '0px'
            menu.classList.add('hidden');
            document.removeEventListener('click', this.documentClickHandler);
        }
    },

    kurulumDetayi(){
      this.kurulumDetay = this.currentRow  
      this.kurulumModalOpen = this.getRandomInt()      
      this.$parent.$bvModal.show('kurulum_modal')
    },

    evrakDetayi(){   
      this.evrakDetay = this.currentRow  
      this.evrakModalOpen = this.getRandomInt()      
      this.$parent.$bvModal.show('evrak_modal')
    },

    detay(index){
      this.$store.dispatch('userDetail/setUserDetail', { ...this.rows[index], bilgi:true });
      this.$parent.$bvModal.show('update_modal')
    },

    cihaz(){
      this.antenData = this.currentRow 
      this.antenModalOpen = this.getRandomInt()
      this.$parent.$bvModal.show('anten_modal')
    },

    bitisTarihi(tarih){
        return this.formatDate(tarih, "DD.MM.YYYY HH:mm:ss");
    },

    gunFark(hedefTarih) {
      var suAnkiTarih = new Date();
      var hedefTarihObj = new Date(hedefTarih);
      var gunFarki = Math.floor((  hedefTarihObj - suAnkiTarih ) / (1000 * 60 * 60 * 24));
      return gunFarki;
    },

    aptList(idx){
      this.apartmentListOpen = this.getRandomInt()
      this.selectApartmentId = idx
      this.$parent.$bvModal.show('client-list-scoped')
    },

    satis(){
      this.satisData = { subscription_id: this.currentRow.id }
      this.satisModalOpen = this.getRandomInt()
      this.$parent.$bvModal.show('satis_modal')
    },

    openMobilMenu(props, index){
      this.currentRow = props
      this.rowIndex = index
      const menuHeight = 471

      const ele = document.getElementById('vgt-table'); 
      ele.style.minHeight = menuHeight + 'px'

      const menu = document.getElementById('menu' + index);
      menu.style.top = `0px`;
      menu.style.left = `0px`;
      menu.classList.remove('hidden');
  },

    closeMobilMenu(index){
      this.currentRow = {}
      this.rowIndex = null
      const menuHeight = 0

      const ele = document.getElementById('vgt-table'); 
      ele.style.minHeight = menuHeight + 'px'

      const menu = document.getElementById('menu' + index);
      menu.classList.add('hidden');
    },

    linkSend({balance, id }){
      let _amount = parseFloat(balance)
      this.paylinkData = { amount: Math.abs(_amount), subs_id :id}
      this.paylinkModalOpen = this.getRandomInt()
      this.$parent.$bvModal.show('paylink_modal')
    },

    removeLine(idx){
      this.$store.dispatch('searchClient/removeLine', idx);
    },

    sokumdenGeriAl({id}){
       this.loading = true
       this.$http.get(`/listeler/sokumden-cikart/` + id )
        .then(response => {
            this.loading = false
            if(response.data.code == 100){
              return notify.success(response.data.message)
            }
            return notify.error(response.data.message)
          })
    },

    geciciHizArttir(prop){
      this.hizModalOpen += 1
      this.hizData = { id:prop.id, tariff_name:prop.tariff_name,tariff_id:prop.tariff_id }
      this.$parent.$bvModal.show('speed_modal')
    },

    portYonlendir(prop){
      this.portModalOpen += 1
      this.portData = { id:prop.id,expiredate:prop.expiredate }
      this.$parent.$bvModal.show('port_modal')
    },

    smsGonder(prop){
      this.smsModalOpen += 1
      this.smsData = { id:prop.id }
      this.$parent.$bvModal.show('sms_modal')
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <SmsModal 
      :modelOpen="smsModalOpen" 
      :data="smsData" />

    <PortModal 
      :modelOpen="portModalOpen" 
      :data="portData" />

    <SpeedModal 
      :modelOpen="hizModalOpen" 
      :data="hizData" />

    <CreateSetup  
      :data="modelOpen"
      :type="data.type" 
      :subs_id="data.subs_id" 
      :referans="data.referans"  />

    <FreezeModal 
      :data="freezeData" />

    <RenewalModal 
      :data="renewalData" 
      :subsBalance="subsBalance" 
      :modelOpen="renewalModalOpen" 
    />

    <HistoryModal 
      :data="historyData" 
    />

    <UpdateModal 
    />

    <PaymentHistoryModal 
      :data="paymentHistoryData" 
    />

    <CreatePaymentModal />

    <SetupList 
      :data="setupData" 
    />

    <AptModal 
      :data="aptData" 
    />

    <FaultHistory 
      :data="faultData" 
    />

    <KurulumModal 
      :data="kurulumDetay" 
      :modelOpen="kurulumModalOpen" 
    />

     <EvrakModal 
      :data="evrakDetay" 
      :modelOpen="evrakModalOpen" 
    />

    <AntenModal 
      :data="antenData" 
      :modelOpen="antenModalOpen" 
    />

    <SatisModal  
      :data="satisData" 
      :modelOpen="satisModalOpen"
    />

    <ApartmentUnderClientList 
      :apartmanetId="selectApartmentId" 
      :modelOpen="apartmentListOpen"
    />

    <PayLink 
      :modelOpen="paylinkModalOpen"
      :data="paylinkData" 
    />

  <div class="row" id="searchBar">
      <div class="col-md" style="position:relative" v-for="list in searchList" :key="list.name">
        <input 
          :placeholder="list.title"
          v-model="search[list.val]"
          @keyup="fetchOptions('', list.val)" 
          @click="searchColumn = list.val;openResult=true" 
          type="search"  
          class="form-control" />
          <div class="row"  v-if="searchColumn == list.val && openResult && subsList[list.val].length > 0">
            <div 
                style="margin-top:5px;background: #fff;border-radius: 5px;padding: 0px;position: absolute;width: 100%;z-index:50;border:solid 1px grey;">
                <div class="text-light" style="background:darkblue;padding:2px;font-size:12px;text-align:center" @click="openResult=false">
                x Kapat
                </div>
                <ul style="margin:0;list-style: none;padding: 0px;overflow-y: scroll;max-height:300px">
                  <li class="__li" @click="changedLabel(sub)" style="padding:5px;" v-for="(sub,i) in subsList[list.val]" :key="i" :data-id="sub.id">{{ sub.username  }} / {{ sub.fname  }} {{ sub.lname  }}</li>
                </ul>
            </div>
          </div>
      </div>
      <div class="col text-end">
        <button class="btn btn-outline-info btn-block" style="width:100%" @click="fetchOptions">Getir</button>
      </div>
  </div>
 
  <div class="row">
    <Transition  name="fade" v-if="detailSearch">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <form class="needs-validation" @submit.prevent="formSubmit">
                <div class="row">
                <div class="col-xl-3">
                  <div class="mb-3">
                      <div class="mb-3">
                      <label for="">İsim Soyisim</label>
                        <v-select
                              label="name" 
                              v-model="form.dealer"
                              :options="list.dealers" 
                              :reduce="df => df.id">
                        <span slot="no-options">Sonuç Bulunamadı</span>
                      </v-select>
                    </div>
                  </div>
                </div>
                <div class="col-xl-3">
                  <div class="mb-3">
                      <div class="mb-3">
                      <label for="">Tel</label>
                        <v-select
                              label="name" 
                              v-model="form.dealer"
                              :options="list.dealers" 
                              :reduce="df => df.id">
                        <span slot="no-options">Sonuç Bulunamadı</span>
                      </v-select>
                    </div>
                  </div>
                </div>
                <div class="col-xl-3">
                  <div class="mb-3">
                      <div class="mb-3">
                      <label for="">İp</label>
                        <v-select
                              label="name" 
                              v-model="form.dealer"
                              :options="list.dealers" 
                              :reduce="df => df.id">
                        <span slot="no-options">Sonuç Bulunamadı</span>
                      </v-select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                  <div class="col">
                    <div class="mb-3">
                      <label for="">Servis Türü</label>
                      <select class="form-select form-select-sm"  v-model="form['tarife_turu']" @change="tariff($event)">
                        <option value="">Tüm Türler</option>
                        <option value="ADSL">ADSL</option>
                        <option value="WIFI">Wireless</option>
                      </select>
                    </div>
                  </div>
                  <div class="col">
                    <div class="mb-3">
                      <label for="">Servis</label>
                      <v-select
                              label="name" 
                              v-model="form.tariff"
                              :options="list.tariffs" 
                              :reduce="df => df.id">
                        <span slot="no-options">Sonuç Bulunamadı</span>
                      </v-select>
                    </div>
                  </div>
                  <div class="col">
                    <div class="row">
                        <div class="col-md-12">
                          <div class="mb-3">
                            <label class="d-flex justify-content-between">Üyelik Tarihi 
                              <span 
                                v-if="form.startdate || form.startdateend" 
                                class="text-danger" 
                                @click="form.startdate= '' ;form.startdateend= ''">
                                temizle</span></label>
                            <div class="input-group">
                              <input type="date" class="form-control"  v-model="form['startdate']">
                              <button style="border:0;background: transparent;">  - </button>
                              <input type="date" class="form-control"  v-model="form['startdateend']">
                            </div>
                          </div>
                        </div>
                    </div>
                  </div>
                  <div class="col">
                    <div class="row">
                        <div class="col-md-12">
                          <div class="mb-3">
                            <label class="d-flex justify-content-between">Bitiş Tarihi 
                              <span 
                              v-if="form.enddate || form.enddateend" 
                              class="text-danger" 
                              @click="form.enddate = '';form.enddateend= ''">temizle</span></label>
                            <div class="input-group">
                              <input type="date" class="form-control"  v-model="form['enddate']">
                              <button style="border:0;background: transparent;">  - </button>
                              <input type="date" class="form-control"  v-model="form['enddateend']">
                            </div>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4 offset-md-8 text-end">
                    <div class="button-items">
                        <button 
                          type="submit"
                          class="btn btn-outline-danger"  
                          @click="allClear()" 
                          >
                          Sorguyu Temizle
                        </button>
                        <button 
                          type="submit"
                          class="btn btn-primary"   
                          >
                            Sorgula
                        </button>
                    </div>
                  </div>
                </div>    
              </form>
              <!-- end card -->
          </div>
        </div>
      </div>
    </Transition>
  </div>
    <div class="row mt-3" style="position:relative" id="vgt-table" v-if="liste.length">
      <div class="col-12">
        <div class="table-responsive">
          <table class="table table-sm">
            <thead>
                <tr>
                  <th></th>
                  <th></th>
                  <th>Tip</th>
                  <th>Kullanıcı Adı</th>
                  <th>İsim Soyisim</th> 
                  <th>Kalan Gün</th>
                  <th>Bitiş Tarihi</th>
                  <th>Taksit Bitiş Tarihi</th>
                  <th>Adres</th>
                  <th>İlçe/Bölge</th>
                  <th class="text-end">Bakiye</th>
                </tr>
              </thead>
            <tbody>
              <tr :id="`line${i}`" v-for="(row,i) in liste" :key="i"  >
                <td class="p-1" style="width:5px">
                  <button @click="removeLine(i)" style="border:none">
                    <i class="bx bx-minus"></i>
                  </button>  
                </td>
                <td>
                  <button @click="openMobilMenu(row,i)" class="btn btn-outline-info d-block d-xl-none btn-sm mb-1 mb-sm-0">
                    <i class="bx bx-menu"></i>
                  </button>  
                   
                  <button  v-if="ability('admin|personel|callcenter')" @click="detay( i)" class="btn btn-outline-info btn-sm">
                    <i class="bx bx-search-alt-2"></i>
                  </button>  
                   
                   <button  @click="aptList(row.apartment_id)" v-if="ability('admin|personel|callcenter') && row.apartment_id && row.apartment_id > 0" class="btn btn-outline-success btn-sm" style="margin-left:2px">
                     Apt. Sistemi
                    </button>
                      <div :id="`menu${i}`" class="_menu absolute hidden py-2">
                       <Loader :loading="true" :load="loading">
                        <ul class="menu-list">
                          <li class="menu-item d-block d-sm-none">
                            <div class="text-light" style="background:darkblue;padding:2px;font-size:12px;text-align:center;border-radius:20px;margin-bottom:20px" @click="closeMobilMenu(i)">
                              x Kapat
                              </div>
                          </li>
                          <li class="menu-item" v-if="row.status != 3 && row.status != 4 && getAntenSetting && ability('admin|personel|callcenter')">
                            <button class="menu-button" @click="cihaz()"><i class="bx bx-pulse"></i> Cihaza Bağlan</button>
                          </li>
                          <li class="menu-item" v-if="row.status != 3 && row.status != 4 ">
                            <button class="menu-button" @click="gunEkle()"><i class="bx bx-plus"></i> +2 Gün Ekle</button>
                          </li>
                          <li class="menu-item"  v-if="ability('admin|personel|callcenter')">
                            <button class="menu-button" @click="bilgiler()"><i class="bx bxs-user-pin"></i> Genel Bilgiler</button>
                          </li>
                          <li class="menu-item"  v-if="row.status != 3  && row.status != 4 && ability('admin|personel')">
                            <button class="menu-button" @click="apt()"><i class="bx bxs-user-pin"></i> Apartman Sistemine Ekle/ Çıkar</button>
                          </li>
                        </ul>
                        <ul class="menu-list" v-if="row.status != 3 && ability('admin|personel|dealer|callcenter')">
                          <li class="menu-item">
                            <button class="menu-button"><i class="bx bx-edit"></i> Bilgi Güncelle<i class="mdi mdi-menu-right"></i></button>
                            <ul class="menu-sub-list">
                              <li class="menu-item"  v-if="ability('admin|personel|dealer')"><button class="menu-button" @click="guncelle('fullname')">İsim, Soyisim değiştir</button></li>
                              <li class="menu-item" ><button class="menu-button" @click="guncelle('contact')">İletişim Bilgileri değiştir</button></li>
                              <li class="menu-item" v-if="ability('admin')"><button class="menu-button" @click="guncelle('network')">İp değiştir</button></li>
                              <li class="menu-item" v-if="ability('admin')"><button class="menu-button" @click="guncelle('password')">Şifre değiştir</button></li>
                              <li class="menu-item" v-if="row.status != 4 && ability('admin')"><button class="menu-button" @click="guncelle('expiredate')">Bitiş Tarihi değiştir</button></li>
                              <li class="menu-item" v-if="row.status != 4 && ability('admin')"><button class="menu-button" @click="guncelle('service')">Servis değiştir</button></li>
                              <li class="menu-item" v-if="ability('admin')"><button class="menu-button" @click="guncelle('dealer')">Bayi değiştir</button></li>
                              <li class="menu-item" v-if="ability('admin|personel|callcenter')"><button class="menu-button" @click="portYonlendir(row)">Port Yönlendir</button></li>
                               <li class="menu-item" v-if="ability('admin|personel|callcenter')"><button class="menu-button" @click="smsGonder(row)">Sms Gönder</button></li>
                            </ul>
                          </li>
                          <li class="menu-item"  v-if="ability('admin|personel|callcenter')">
                            <button class="menu-button" @click="geciciHizArttir(row)"><i class="bx bx-transfer"></i> Geçici Hız Tanımla</button>
                          </li>
                        </ul>
                        <ul class="menu-list" v-if="row.status != 3">
                          <li class="menu-item" v-if="ability('admin|personel|callcenter')">
                            <button class="menu-button menu-button--black" ><i class="bx bx-credit-card"></i>Ödeme İşlemleri<i class="mdi mdi-menu-right"></i></button>
                            <ul class="menu-sub-list">
                              <li class="menu-item" v-if="ability('admin|personel')"><button class="menu-button" @click="createPayment(1)" >Nakit</button></li>
                              <li class="menu-item" v-if="ability('admin|personel')"><button class="menu-button" @click="createPayment(2)">Kredi Kartı</button></li>
                              <li class="menu-item" v-if="ability('admin|personel')"><button class="menu-button" @click="createPayment(4)">Havale</button></li>
                              <li class="menu-item"  v-if="ability('admin|personel')"><button class="menu-button" @click="createPayment(3)">Çek</button></li>
                              <li class="menu-item"  v-if="ability('admin|personel')"><button class="menu-button" @click="createPayment(5)">Veresiye</button></li>
                              <li class="menu-item"  v-if="ability('admin|personel|callcenter')"><button class="menu-button" @click="linkSend(row)">Ödeme Linki Gönder</button></li>
                              <li class="menu-item"  v-if="ability('admin|personel|callcenter')" style="border-top: 1px solid #ddd;"><button class="menu-button" @click="paymentHistory()">Ödeme Geçmişi</button></li>
                            </ul>
                          </li>
                          <li class="menu-item" v-if="row.status != 4  && ability('admin|personel|callcenter|dealer')">
                            <button class="menu-button menu-button--black" @click="yenile()"  ><i class="bx bx-revision"></i> Üyelik Yenile</button>
                          </li>
                          <li class="menu-item" v-if="ability('admin|personel')">
                            <button class="menu-button menu-button--black" @click="satis()"  ><i class="bx bx-cart-alt"></i> Ürün Satış</button>
                          </li>
                        </ul>
                       

                        <ul class="menu-list"  v-if="ability('admin|personel|callcenter')"> 
                          <li class="menu-item">
                            <button class="menu-button menu-button--black"><i class="bx bx-history"></i>Geçmişler<i class="mdi mdi-menu-right"></i></button>
                            <ul class="menu-sub-list">
                              <li class="menu-item" v-if="ability('admin|personel')"><button class="menu-button" @click="islemler()">İşlemler</button></li>
                              <li class="menu-item" v-if="ability('admin|personel')"><button class="menu-button" @click="port()">Port Geçmişi</button></li>
                              <li class="menu-item" v-if="ability('admin|personel')"><button class="menu-button" @click="baglanti()">Bağlantı Geçmişi</button></li>
                              <li class="menu-item" v-if="ability('admin|personel|callcenter')">
                                <button class="menu-button menu-button" @click="arizaListesi()">Arıza Geçmişi</button>
                              </li>
                              <li class="menu-item"  v-if="row.status == 3 && ability('admin|personel|callcenter')" style="border-top: 1px solid #ddd;"><button class="menu-button" @click="paymentHistory()">Ödeme Geçmişi</button></li>
                            </ul>
                          </li>
                        </ul>
                        <ul class="menu-list"  v-if="ability('admin|personel|callcenter')">
                          <li class="menu-item" v-if="ability('admin|personel')">
                            <button class="menu-button menu-button" @click="kurulumDetayi()"><i class="bx bx-building-house"></i> Kurulum Detayı</button>
                          </li>
                           <li class="menu-item" v-if="ability('admin|personel')">
                            <button class="menu-button menu-button" @click="evrakDetayi()"><i class="bx bx-folder"></i> Evrak Detayı</button>
                          </li>
                          <li class="menu-item" v-if="row.status == 3">
                            <button class="menu-button menu-button" @click="sokumdenGeriAl(row)"><i class="bx bx-revision"></i> Sökümden Geri Al</button>
                          </li>
                          <li class="menu-item" v-if="row.status != 3">
                            <button class="menu-button menu-button" @click="ariza()"><i class="bx bx-wrench"></i> Arıza Ekle</button>
                          </li>
                          <li class="menu-item">
                            <button class="menu-button menu-button" @click="tasima()"><i class="bx bx-space-bar"></i> Taşıma Ekle</button>
                          </li>
                          <li class="menu-item" v-if="row.status != 3">
                            <button class="menu-button menu-button" @click="sokum()"><i class="bx bx-undo"></i> Söküm Ekle</button>
                          </li>
                        </ul>
                        <ul class="menu-list" v-if="row.status != 3">
                          <li class="menu-item" v-if="row.status == 1 || row.status == 2">
                            <button class="menu-button menu-button" @click="reConnect()"><i class="bx bx-link"></i> Bağlantı Yenile</button>
                          </li>
                          <li class="menu-item" v-if="ability('admin|personel')">
                            <button class="menu-button menu-button" @click="dondur()">
                              <span class="d-flex" v-if="row.status == 4"><i class="bx bx-play-circle text-success"></i>  Hesabı Çöz</span>
                              <span class="d-flex" v-else><i class="bx bx-stop-circle orange"></i>  Hesabı Dondur</span>
                           </button>
                          </li>
                        </ul>
                       </Loader>
                      </div>
                </td>
                <td @contextmenu="context($event,row, i)"><i class="bx bx-wifi"></i></td>
                <td @contextmenu="context($event,row, i)" :style="`background-color:${ isOnline == 1 ? '#7eff7e' : '' }`">{{ row.username }}</td>
                <td @contextmenu="context($event,row, i)" :style="`background-color:${ row.labelColor }`">{{ row.fname }} {{ row.lname }}</td>
                <td @contextmenu="context($event,row, i)">
                    {{ gunFark(row.expiredate) }} Gün <br>
                    {{ row.label }} 
                </td>
                <td @contextmenu="context($event,row, i)">
                    {{ bitisTarihi(row.expiredate) }} <br>
                </td>
                 <td @contextmenu="context($event,row, i)">
                   <span v-if="row.installment">{{ bitisTarihi(row.installment_expiredate) }}</span><br>
                   <span v-if="row.installment"> Kalan Taksit - ({{row.installment.remaining }})</span>
                </td>
                <td @contextmenu="context($event,row, i)">{{ row.address }}</td>
                <td @contextmenu="context($event,row, i)">{{ row.province }} / {{ row.township }}</td>
                <td @contextmenu="context($event,row, i)" class="text-end">
                  <span v-if="row.balance > 0"><strong style="color:green">{{ row.balance }}</strong> TL</span>
                  <span v-else-if="row.balance == 0"><strong class="text-warning">-</strong></span>
                  <span v-else><strong style="color:red">{{ row.balance }}</strong> TL</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </Layout>
</template>